var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Stack, Toggle, useTheme } from "@fluentui/react";
import React, { useId } from "react";
import { getResources } from "../../../getResources";
import { getDisplayFlex } from "../EvolvedSettingsDialog.styles";
import EvolvedSettingsAction from "./EvolvedSettingsAction";
import { getActionIconStackStyle, getToggleStyle, } from "./EvolvedSettingsAction.styles";
// An object that toggles while providing text and optionally two icons which is treated as a button by the UX.
const EvolvedSettingsToggle = React.memo((_a) => {
    var { title, onClick, isChecked, disabled } = _a, rest = __rest(_a, ["title", "onClick", "isChecked", "disabled"]);
    const theme = useTheme();
    const id = "action-toggle-setting-" + useId();
    function onToggle() {
        onClick(!isChecked);
    }
    return React.createElement(EvolvedSettingsAction, Object.assign({ id: id, title: title, actionNode: React.createElement(Stack.Item, { styles: getDisplayFlex(getActionIconStackStyle(true)) },
            React.createElement(Toggle, { ariaLabel: title, styles: getToggleStyle(theme), checked: isChecked, onText: getResources().SettingsDialog_ToggleOnText, offText: getResources().SettingsDialog_ToggleOffText, onClick: onToggle, disabled: disabled })) }, rest));
});
export default EvolvedSettingsToggle;
